import request from "./request";

const api = {
  signup: "user/signup",
  login: "user/login",
  getUserInfo: "user/getUserInfo",
  verify: "user/verify",
  updatePwd: "user/updatePwd",
  updateTradePwd: "user/updateTradePwd",
  resetPwd: "user/resetPwd",
  update: "user/update",
  getProfit: "user/getProfit",
  getIncomeRand: "user/getIncomeRand",
  saveAvatar: "user/saveAvatar",
};
export default {
  signup(parameter) {
    return request({
      url: api.signup,
      method: "POST",
      data: parameter,
    });
  },
  saveAvatar(parameter) {
    return request({
      url: api.saveAvatar,
      method: "POST",
      data: parameter,
    });
  },
  getIncomeRand(parameter) {
    return request({
      url: api.getIncomeRand,
      method: "POST",
      data: parameter,
    });
  },
  getProfit(parameter) {
    return request({
      url: api.getProfit,
      method: "POST",
      data: parameter,
    });
  },
  update(parameter) {
    return request({
      url: api.update,
      method: "POST",
      data: parameter,
    });
  },
  resetPwd(parameter) {
    return request({
      url: api.resetPwd,
      method: "POST",
      data: parameter,
    });
  },
  verify(parameter) {
    return request({
      url: api.verify,
      method: "POST",
      data: parameter,
    });
  },
  login(parameter) {
    return request({
      url: api.login,
      method: "POST",
      data: parameter,
    });
  },
  getUserInfo(parameter) {
    return request({
      url: api.getUserInfo,
      method: "POST",
      data: parameter,
    });
  },
  updatePwd(parameter) {
    return request({
      url: api.updatePwd,
      method: "POST",
      data: parameter,
    });
  },
  updateTradePwd(parameter) {
    return request({
      url: api.updateTradePwd,
      method: "POST",
      data: parameter,
    });
  },
};
